import { useEffect, useRef } from "react";

export const useIntersectionObserver = (
  setActiveId: (arg0: string) => void
) => {
  const sectionsRef = useRef({});
  useEffect(() => {
    const callback = (sections) => {
      sectionsRef.current = sections.reduce((map, sectionElement) => {
        map[sectionElement.target.id] = sectionElement;
        return map;
      }, sectionsRef.current);

      // Get all sections that are currently visible on the page
      const visibleSections: { [key: string]: { id: string } }[] = [];
      Object.keys(sectionsRef.current).forEach((key) => {
        const sectionElement = sectionsRef.current[key];
        if (sectionElement.isIntersecting) visibleSections.push(sectionElement);
      });

      if (visibleSections[0]) setActiveId(visibleSections[0].target.id);
    };

    const observer = new IntersectionObserver(callback, {
      rootMargin: "-300px 0px 0px 0px",
    });

    const sectionElements = Array.from(
      document.querySelectorAll(".briefings__content")
    );
    sectionElements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [setActiveId]);
};
